<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <ButtonLinkAdd
                                            :url="
                                                route('jenispengadaan.create')
                                            "
                                            class="mr-1"
                                            >Tambah</ButtonLinkAdd
                                        >
                                        <ButtonDelete
                                            :disabled="
                                                selected_jenis_pengadaan.length == 0 ||
                                                !allow_to_proceed
                                            "
                                            label="Hapus"
                                            @click="hapus($event)"
                                            class="mr-1"
                                        />
                                        <ButtonLinkShow
                                            :disabled="
                                                selected_jenis_pengadaan.length != 1
                                            "
                                            :url="
                                                route('jenispengadaan.show', {
                                                    id: selected_jenis_pengadaan_id,
                                                })
                                            "
                                            class="mr-1"
                                            >Lihat</ButtonLinkShow
                                        >
                                    </template>
                                    <template #end>
                                    </template>
                                </Toolbar>
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedJenisPengadaan"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import EzDataTable from "@/Components/EzDataTable";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import ButtonLinkAdd from "@/Components/ButtonLinkAdd";
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import ButtonLinkShow from "@/Components/ButtonLinkShow";
import ButtonDelete from "@/Components/ButtonDelete";
import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        EzDataTable,
        Toolbar,
        Button,
        ButtonLinkAdd,
        ButtonLinkEdit,
        ButtonLinkShow,
        ButtonDelete,
    },
    data() {
        return {
            ezdtConfig: {
                dtHeader: "Daftar Jenis Pengadaan",
                globalFilter: ["nama_jenis_pengadaan"],
                sortBy: "created_at",
                defineCols: [
                    {
                        field: "nama_jenis_pengadaan",
                        header: "Nama Jenis Pengadaan",
                        style: "min-width: 20rem",
                        col_type: "text",
                    },
                    {
                        field: "jml_tahapan",
                        header: "Jml Tahapan",
                        style: "min-width: 7rem",
                        col_type: "numeric",
                        isSortAble: false,
                        isFilterAble: false,
                    },
                    {
                        field: "created_at",
                        header: "Dibuat Tgl",
                        style: "min-width: 15rem",
                        col_type: "date",
                    },
                ],
                dtSourceApiRoute: {
                    list: "jenispengadaan.data",
                    drop: "jenispengadaan.bulkdelete",
                    edit: "jenispengadaan.edit",
                    destroy: "jenispengadaan.destroy",
                },
            },
            selected_jenis_pengadaan: [],
            selected_jenis_pengadaan_id: 0,
            allow_to_proceed: true,
        };
    },
    methods: {
        loadEzData: function () {
            this.allow_to_proceed = false;
            this.$refs.ezdt.loadData();
        },
        getSelectedJenisPengadaan: function (data) {
            this.selected_jenis_pengadaan = data;
            this.selected_jenis_pengadaan_id = 0;
            if (data.length == 1) {
                this.selected_jenis_pengadaan_id = data[0]["id"];
            }
        },
        tambah: function (event) {
            //
        },
        edit: function (event) {
            //
        },
        hapus: function (event) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Delete (" +
                    this.selected_jenis_pengadaan.length +
                    ") selected record ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    let ids = [];
                    this.selected_jenis_pengadaan.forEach(function (item, index) {
                        ids.push(item.id);
                    });

                    this.$refs.ezdt.dropData(ids);
                },
                reject: () => {
                    //
                },
            });
        },
    },
});
</script>
